<template>
	<v-dialog
		v-model="dialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-magnify</v-icon>
			</v-btn>
		</template>

		<v-card :tile="!$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">見積番号検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-form ref="form" class="pa-2">
				<v-row no-gutters>
					<v-col class="p-auto-1" cols="12" sm="6">
						<IncrementalSearchForm
							:value.sync="q.quote_number_cont"
							:label="'見積番号'"
							:itemText="'quote_number'"
							:targetName="'運送費見積'"
							:keywordKey="'quote_number_cont'"
							:url="'/erp/v1/incremental/logi_quote_requests'"
							:classArray="['mt-4', 'append-outer']"
						/>
					</v-col>
					<v-col class="p-auto-1" cols="12" sm="6">
						<v-select
							v-model="q.supplier_id_eq"
							label="運送会社"
							:items="suppliers"
							clearable
							item-value="id"
							item-text="name"
							class="mt-4"
							outlined
							dense
						/>
					</v-col>
					<v-col class="p-auto-1" cols="12" sm="6">
						<v-autocomplete
							v-model="q.logi_quote_logi_quote_cars_car_model_eq"
							label="車種"
							:items="car_models"
							clearable
							class="mt-4"
							outlined
							dense
						/>
					</v-col>
					<v-col class="p-auto-1" cols="12" sm="6">
						<v-select
							v-model="q.prefecture_eq"
							label="都道府県"
							clearable
							:items="$store.state.prefectures"
							class="mt-4"
							outlined
							dense
						/>
					</v-col>
					<v-col class="p-auto-1" cols="12" sm="6">
						<v-text-field v-model="q.city_cont" label="市郡町村" class="mt-4" outlined dense />
					</v-col>
					<v-col class="p-auto-1" cols="12" sm="6">
						<v-menu
							ref="answerDateRangeMenu"
							v-model="answerDateRangeMenu"
							:close-on-content-click="false"
							:return-value.sync="answerDateRange"
							transition="scale-transition"
							offset-y
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="answerDatesText"
									label="回答日"
									class="mt-4"
									clearable
									outlined
									dense
									readonly
									v-bind="attrs"
									v-on="on"
									hint="範囲選択が可能です。"
								></v-text-field>
							</template>
							<v-date-picker
								class="date-picker"
								v-model="answerDateRange"
								no-title
								scrollable
								range
								locale="ja-JP"
							>
								<v-spacer />
								<v-btn text color="grey" @click="answerDateRangeMenu = false"> キャンセル </v-btn>
								<v-btn
									text
									color="primary"
									@click="changeDateRange('answerDateRange', 'answer_date')"
								>
									決定
								</v-btn>
							</v-date-picker>
						</v-menu>
					</v-col>
				</v-row>
			</v-form>
			<v-row no-gutters justify="center">
				<v-btn color="secondary" @click="searchQuoteRequests(1)">
					<v-icon class="mr-1">mdi-magnify</v-icon>
					検索
				</v-btn>
			</v-row>
			<div class="pa-2" v-if="quoteRequests.length">
				<v-divider class="mt-4" />
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:items="quoteRequests"
						:headers="headers"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr class="clickable" @click="showConfirmMenu($event, item)">
								<td>{{ item.quote_number }}</td>
								<td>{{ common.formatDate(item.quote_date) }}</td>
								<td>{{ common.formatDate(item.answer_date) }}</td>
								<td>{{ item.quote_expiration_period }}</td>
								<td>{{ item.matter.name }}</td>
								<td>{{ item.title }}</td>
								<td>{{ item.supplier.name }}</td>
								<td>{{ item.logi_quote.prefecture }}</td>
								<td>{{ item.logi_quote.city }}</td>
								<td>{{ item.logi_quote.address }}</td>
								<td>
									<p
										v-for="car in item.logi_quote.logi_quote_cars"
										v-text="car.car_model"
										:key="car.id"
									/>
								</td>
								<td>
									<p
										v-for="car in item.logi_quote.logi_quote_cars"
										v-text="car.number_of_cars"
										:key="car.id"
									/>
								</td>
								<td>{{ Number(item.logi_quote.price).toLocaleString() }}円</td>
								<td>{{ item.user.full_name }}</td>
							</tr>
						</template>
					</v-data-table>
					<v-menu v-model="confirmMenu" :position-x="x" :position-y="y" absolute offset-y>
						<v-list>
							<v-list-item @click="selectData">
								<v-list-item-title>指定した見積番号を設定する</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
				<PaginationModule :pagination="pagination" @get-page="searchQuoteRequests($event)" />
			</div>
			<v-card-actions>
				<v-row no-gutters justify="end">
					<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import Qs from "qs"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"
import PaginationModule from "../../../modules/PaginationModule.vue"

export default {
	props: {
		suppliers: {
			type: Array,
			required: true,
			default: () => [],
		},
		car_models: {
			type: Array,
			required: true,
			default: () => [],
		},
	},
	components: {
		IncrementalSearchForm,
		PaginationModule,
	},
	data() {
		return {
			dialog: false,
			answerDateRange: [],
			answerDateRangeMenu: false,
			quoteRequests: [],
			headers: [
				{
					text: "見積依頼番号",
					value: "quote_number",
					width: "120px",
				},
				{
					text: "見積依頼日",
					value: "quote_date",
					width: "100px",
				},
				{
					text: "回答日",
					value: "answer_date",
					width: "100px",
				},
				{
					text: "回答有効期限(日数)",
					value: "quote_expiration_period",
					width: "100px",
				},
				{
					text: "関連案件名",
					value: "matter.name",
					width: "250px",
				},
				{
					text: "件名",
					value: "title",
					width: "200px",
				},
				{
					text: "運送会社",
					value: "supplier.name",
					width: "150px",
				},
				{
					text: "都道府県",
					value: "logi_quote.prefecture",
					width: "100px",
				},
				{
					text: "市郡町村",
					value: "logi_quote.city",
					width: "100px",
				},
				{
					text: "住所",
					value: "logi_quote.address",
					width: "200px",
				},
				{
					text: "車種",
					value: "logi_quote.car_model",
					width: "200px",
				},
				{
					text: "台数/式",
					value: "logi_quote.number_of_cars",
					width: "100px",
				},
				{
					text: "金額",
					value: "logi_quote.price",
					width: "200px",
				},
				{
					text: "見積依頼者",
					value: "user.full_name",
					width: "200px",
				},
			],
			q: {
				quote_number_cont: null,
				answer_date_gteq: null,
				answer_date_lteq: null,
				logi_quote_supplier_id_eq: null,
				logi_quote_car_model_eq: null,
				logi_quote_prefecture_eq: null,
				logi_quote_city_cont: null,
			},
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			confirmMenu: false,
			selectedQuoteRequest: null,
			x: 0,
			y: 0,
			common: common,
		}
	},
	methods: {
		showConfirmMenu(e, quote_request) {
			this.selectedQuoteRequest = quote_request
			this.confirmMenu = false
			this.x = e.clientX
			this.y = e.clientY
			this.$nextTick(() => {
				this.confirmMenu = true
			})
		},

		searchQuoteRequests(page) {
			const headers = authenticate.setHeader()
			const params = { page: page, q: this.q }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })

			axios
				.get("/erp/v1/delivery_orders/search_quote_requests", {
					params,
					paramsSerializer,
					headers,
				})
				.then((response) => {
					this.quoteRequests = response.data.quote_requests
					this.pagination = response.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeDateRange(dateRange, queryName) {
			if (this[dateRange].length) {
				const firstDate = this[dateRange][0]
				const lastDate = this[dateRange][this[dateRange].length - 1]
				if (firstDate > lastDate) {
					this.q[`${queryName}_gteq`] = lastDate
					this.q[`${queryName}_lteq`] = firstDate
				} else {
					this.q[`${queryName}_gteq`] = firstDate
					this.q[`${queryName}_lteq`] = lastDate
				}
			} else {
				this.q[`${queryName}_gteq`] = null
				this.q[`${queryName}_lteq`] = null
			}
			this.$refs[`${dateRange}Menu`].save(this[dateRange])
		},
		selectData() {
			this.$emit("set-quote-request", this.selectedQuoteRequest)
			this.dialog = false
		},
	},
	computed: {
		answerDatesText: {
			get() {
				return this.answerDateRange.length
					? this.answerDateRange.map((d) => common.formatDate(d)).join(" ~ ")
					: null
			},
			set(newVal) {
				this.answerDateRange = []
				this.changeDateRange("answerDateRange", "answer_date")
				return
			},
		},
	},
}
</script>